import { createReducer, PayloadAction } from '@reduxjs/toolkit';

import { array, option } from 'fp-ts';
import { pipe } from 'fp-ts/function';
import { ConfigurationResult } from '@mews-distributor/data-access';
import { keyById } from '@mews/fp';
import { FETCH_CONFIGURATIONS_SUCCEEDED } from '../../configuration/actionTypes';
import { Enterprise, Enterprises } from './types';

const initialState: Enterprises = {};

export const enterprisesReducer = createReducer(initialState, (builder) => {
    builder.addCase(
        FETCH_CONFIGURATIONS_SUCCEEDED,
        (
            state,
            {
                payload: { enterprises, bookingEngines, services },
            }: PayloadAction<ConfigurationResult, typeof FETCH_CONFIGURATIONS_SUCCEEDED>
        ) => {
            const getServiceConfigurationId = (enterpriseId: string) =>
                pipe(
                    services,
                    array.findFirst((service) => service.enterpriseId === enterpriseId),
                    option.flatMap(({ id }) =>
                        pipe(
                            bookingEngines,
                            array.findFirst((bookingEngine) => bookingEngine.serviceId === id),
                            option.map((bookingEngine) => bookingEngine.id)
                        )
                    ),
                    option.toNullable
                );

            /**
             * TODO: Custom Enterprise types are far from reality - old enpoint returned combined data withing enterprise
             * such as `rates`, address object etc.
             * I used `as unknown as Array<Enterprise>`, but it needs to be narrowed ASAP.
             */
            const enterprisesWithConfigurationId = pipe(
                enterprises,
                array.map((enterprise) => {
                    const configurationId = getServiceConfigurationId(enterprise.id);
                    return { ...enterprise, configurationId };
                })
            ) as unknown as Array<Enterprise>;

            return {
                ...state,
                ...keyById(enterprisesWithConfigurationId),
            };
        }
    );
});
